import { Button, showNotification } from 'design-system';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchGraveDetails } from '../../actionCable/channels/userNotification';
import {
  setUserNotificationButton,
  setUserNotificationRequestStatusRedux,
} from '../../redux/actions';
import { authHeader, fetch_request, request } from '../../service/request';
import { getRoomTabPath } from '../../service/constants';
import './Notifications.css';

const RequestActionButtons = ({ notification, inline = false }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const broadcastMoonStatusChanged = (detail = {}) => {
    if (typeof window === 'undefined' || typeof window.dispatchEvent !== 'function') return;
    try {
      window.dispatchEvent(new CustomEvent('moon-status-changed', {detail}));
    } catch {}
  };

  const setRelations = (status, item, onSuccess) => {
    let formdata = new FormData();
    formdata.append('grave_user_id', item.extra_info.grave_user_id);
    formdata.append('status', status);

    const requestOptions = {
      method: 'POST',
      redirect: 'follow',
      headers: {
        ...authHeader(),
        Accept: '*/*',
      },
      body: formdata,
    };

    fetch_request('/api/relation_approvals', requestOptions)
      .then((res) => {
        let formdata = new FormData();
        formdata.append('status', status);
        formdata.append('show_button', false);
        formdata.append('read', true);
        fetch_request(`/api/notifications/${item.id}`, {
          ...requestOptions,
          method: 'put',
          body: formdata,
        })
          .then((e) => {
            if (status === 'accepted') {
              fetchGraveDetails(item.extra_info.slug);
            }
            onSuccess && onSuccess();
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => console.log(err));
  };

  const setUserConnection = (status, notification, onSuccess) => {
    let formdata = new FormData();
    formdata.append('id', notification.extra_info.id);
    formdata.append('status', status);

    request(`/user_connections/${notification.extra_info.id}`, formdata, 'put')
      .then((res) => {
        let formdata = new FormData();
        formdata.append('status', status);
        formdata.append('show_button', false);
        formdata.append('read', true);
        request(`/notifications/${notification.id}`, formdata, 'put').then((e) => {
          if (status === 'accepted') {
            showNotification(`Relasjonen er godkjent`, 'success', 'requests');
          } else {
            showNotification(`Relasjonen er avvist`, 'success', 'requests');
          }
          onSuccess && onSuccess();
        });
      })
      .catch((err) => {
        // showNotification(err.data.message, 'error');
        console.log(err);
      });
  };

  const setLinkGrave = (status, notification, onSuccess) => {
    let formdata = new FormData();
    formdata.append('link_grave_id', notification.extra_info.id);
    formdata.append('status', status);

    request(`/link_grave_approvals`, formdata, 'post')
      .then((res) => {
        let formdata = new FormData();
        formdata.append('status', status);
        formdata.append('show_button', false);
        formdata.append('read', true);
        request(`/notifications/${notification.id}`, formdata, 'put').then(() => {
          onSuccess && onSuccess();
        });
      })
      .catch((err) => {
        // showNotification(err.data.message, 'error');
        console.log(err);
      });
  };

  const setGraveOwner = (status, notification, onSuccess) => {
    let formdata = new FormData();
    formdata.append('grave_user_id', notification.extra_info.grave_user_id);
    formdata.append('status', status);

    request(`/grave_approvals`, formdata, 'post')
      .then((res) => {
        let formdata = new FormData();
        formdata.append('status', status);
        formdata.append('show_button', false);
        formdata.append('read', true);
        request(`/notifications/${notification.id}`, formdata, 'put').then(() => {
          onSuccess && onSuccess();
        });
      })
      .catch((err) => {
        // showNotification(err.data.message, 'error');
        console.log(err);
      });
  };

  const setCompanyApproval = (status, notification, onSuccess) => {
    let formdata = new FormData();
    if (notification.extra_info.company_id) {
      formdata.append('company_id', notification.extra_info.company_id);
    } else if (notification.extra_info.id) {
      formdata.append('company_id', notification.extra_info.id);
    }
    formdata.append('status', status);

    request(`/company_approvals`, formdata, 'post')
      .then(() => {
        let formdata = new FormData();
        formdata.append('status', status);
        formdata.append('show_button', false);
        formdata.append('read', true);
        request(`/notifications/${notification.id}`, formdata, 'put').then(() => {
          if (status === 'accepted') {
            showNotification(intl.formatMessage({ id: 'company_request_approved' }), {
              variant: 'success',
              context: 'requests',
              id: 'requests.company.approved',
            });
          } else {
            showNotification(intl.formatMessage({ id: 'company_request_declined' }), {
              variant: 'success',
              context: 'requests',
              id: 'requests.company.declined',
            });
          }
          onSuccess && onSuccess();
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const setAdMessageApproval = (status, notification, onSuccess) => {
    let formdata = new FormData();
    if (notification.extra_info.ad_message_id) {
      formdata.append('ad_message_id', notification.extra_info.ad_message_id);
    } else if (notification.extra_info.id) {
      formdata.append('ad_message_id', notification.extra_info.id);
    }
    formdata.append('status', status);

    request(`/ad_message_approvals`, formdata, 'post')
      .then(() => {
        let formdata = new FormData();
        formdata.append('status', status);
        formdata.append('show_button', false);
        formdata.append('read', true);
        request(`/notifications/${notification.id}`, formdata, 'put').then(() => {
          if (status === 'accepted') {
            showNotification(intl.formatMessage({ id: 'ad_request_approved' }), {
              variant: 'success',
              context: 'requests',
              id: 'requests.ad.approved',
            });
          } else {
            showNotification(intl.formatMessage({ id: 'ad_request_declined' }), {
              variant: 'success',
              context: 'requests',
              id: 'requests.ad.declined',
            });
          }
          onSuccess && onSuccess();
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const setGraveInvitation = (status, notification, onSuccess) => {
    const token = notification?.extra_info?.invitation_token;
    if (!token) {
      showNotification(
        intl.formatMessage({ id: 'gravesHub.invitations.actionError' }),
        'error',
        'requests',
      );
      return;
    }

    const action = status === 'accepted' ? 'accept' : 'decline';
    request(`/grave_invitations/${token}/${action}`, {}, 'post')
      .then(() => {
        const messageId =
          status === 'accepted'
            ? 'gravesHub.invitations.acceptSuccess'
            : 'gravesHub.invitations.declineSuccess';
        showNotification(intl.formatMessage({ id: messageId }), 'success', 'requests');

        const formdata = new FormData();
        formdata.append('status', status === 'accepted' ? 'accepted' : 'rejected');
        formdata.append('show_button', false);
        formdata.append('read', true);

        request(`/notifications/${notification.id}`, formdata, 'put').then(() => {
          onSuccess && onSuccess();
        });
        navigate(`/graves/${notification.extra_info.slug}`);
      })
      .catch((err) => {
        const serverMessage =
          typeof err?.response?.data?.error === 'string'
            ? err.response.data.error
            : typeof err?.response?.data?.message === 'string'
              ? err.response.data.message
              : null;
        showNotification(
          serverMessage || intl.formatMessage({ id: 'gravesHub.invitations.actionError' }),
          'error',
          'requests',
        );
      });
  };

  const setMoonRequest = (status, notification, onSuccess) => {
    const token = notification?.extra_info?.invitation_token;
    if (!token) {
      showNotification('Kunne ikke finne måneforespørselen.', 'error', 'requests');
      return;
    }

    request(`/moon_requests/${token}`, {status: status === 'accepted' ? 'accepted' : 'declined'}, 'patch')
      .then(() => {
        showNotification(
          status === 'accepted'
            ? intl.formatMessage({
              id: 'moon_request_accepted',
              defaultMessage: 'Måneinvitasjonen er akseptert.',
            })
            : intl.formatMessage({
              id: 'moon_request_declined',
              defaultMessage: 'Måneinvitasjonen er avslått.',
            }),
          'success',
          'requests',
        );

        const formdata = new FormData();
        formdata.append('status', status === 'accepted' ? 'accepted' : 'rejected');
        formdata.append('show_button', false);
        formdata.append('read', true);

        request(`/notifications/${notification.id}`, formdata, 'put').then(() => {
          broadcastMoonStatusChanged({
            status: status === 'accepted' ? 'accepted' : 'declined',
            fromUserId: notification?.extra_info?.sender_id,
            toUserId: notification?.extra_info?.receiver_id,
          });
          onSuccess && onSuccess();
        });
      })
      .catch((err) => {
        const serverMessage =
          typeof err?.response?.data?.error === 'string'
            ? err.response.data.error
            : typeof err?.response?.data?.message === 'string'
              ? err.response.data.message
              : null;
        showNotification(
          serverMessage || 'Kunne ikke oppdatere måneforespørselen.',
          'error',
          'requests',
        );
      });
  };

  const setGroupInvitation = (status, notification, onSuccess) => {
    const token = notification?.extra_info?.invitation_token;
    const groupId = notification?.extra_info?.group_id;
    const groupMemberId = notification?.extra_info?.group_member_id;
    if ((!token && !groupMemberId) || !groupId) {
      showNotification(
        intl.formatMessage({
          id: 'notifications.group_invite.action_error',
          defaultMessage: 'Could not update the group invitation.',
        }),
        'error',
        'requests',
      );
      return;
    }

    const endpoint =
      status === 'accepted'
        ? `/groups/${groupId}/group_members/accept`
        : `/groups/${groupId}/group_members/decline`;

    const announceGroupInvitationChange = (conversationId) => {
      if (typeof window === 'undefined') return;
      const detail = { groupId, conversationId, status };
      try {
        window.dispatchEvent(new CustomEvent('nettgrav:groups-directory-refresh', { detail }));
      } catch {}
      try {
        window.localStorage?.setItem(
          'nettgrav:groups-directory-refresh',
          JSON.stringify({ ...detail, at: Date.now() }),
        );
      } catch {}
    };

    const openGroup = (conversationId) => {
      if (status !== 'accepted') return;
      navigate(conversationId ? `/messages/groups/${conversationId}` : '/messages');
    };

    request(endpoint, { invitation_token: token, room_member_id: groupMemberId }, 'post')
      .then((response) => {
        const conversationId = response?.data?.conversation?.id;
        showNotification(
          status === 'accepted'
            ? intl.formatMessage({
                id: 'notifications.group_invite.accepted',
                defaultMessage: 'Group invitation accepted.',
              })
            : intl.formatMessage({
                id: 'notifications.group_invite.declined',
                defaultMessage: 'Group invitation declined.',
              }),
          'success',
          'requests',
        );

        const formdata = new FormData();
        formdata.append('status', status === 'accepted' ? 'accepted' : 'rejected');
        formdata.append('show_button', false);
        formdata.append('read', true);

        request(`/notifications/${notification.id}`, formdata, 'put').then(() => {
          onSuccess && onSuccess();
          announceGroupInvitationChange(conversationId);
          openGroup(conversationId);
        });
      })
      .catch((err) => {
        const serverMessage =
          typeof err?.response?.data?.error === 'string'
            ? err.response.data.error
            : typeof err?.response?.data?.message === 'string'
              ? err.response.data.message
              : null;
        showNotification(
          serverMessage ||
            intl.formatMessage({
              id: 'notifications.group_invite.action_error',
              defaultMessage: 'Could not update the group invitation.',
            }),
          'error',
          'requests',
        );
      });
  };

  const setRoomInvitation = (status, notification, onSuccess) => {
    const token = notification?.extra_info?.invitation_token;
    const roomId = notification?.extra_info?.room_id;
    const roomMemberId = notification?.extra_info?.room_member_id;
    if ((!token && !roomMemberId) || !roomId) {
      showNotification(
        intl.formatMessage({
          id: 'notifications.room_invite.action_error',
          defaultMessage: 'Could not update the Room invitation.',
        }),
        'error',
        'requests',
      );
      return;
    }

    const action = status === 'accepted' ? 'accept' : 'decline';
    request(
      `/rooms/${roomId}/room_members/${action}`,
      { invitation_token: token, room_member_id: roomMemberId },
      'post',
    )
      .then(() => {
        showNotification(
          status === 'accepted'
            ? intl.formatMessage({
                id: 'notifications.room_invite.accepted',
                defaultMessage: 'Room invitation accepted.',
              })
            : intl.formatMessage({
                id: 'notifications.room_invite.declined',
                defaultMessage: 'Room invitation declined.',
              }),
          'success',
          'requests',
        );
        const formdata = new FormData();
        formdata.append('status', status === 'accepted' ? 'accepted' : 'rejected');
        formdata.append('show_button', false);
        formdata.append('read', true);
        request(`/notifications/${notification.id}`, formdata, 'put').then(() => {
          onSuccess && onSuccess();
          if (status === 'accepted') navigate(getRoomTabPath(roomId, 'members_chat'));
        });
      })
      .catch((err) => {
        const serverMessage =
          typeof err?.response?.data?.error === 'string'
            ? err.response.data.error
            : typeof err?.response?.data?.message === 'string'
              ? err.response.data.message
              : null;
        showNotification(
          serverMessage || intl.formatMessage({
            id: 'notifications.room_invite.action_error',
            defaultMessage: 'Could not update the Room invitation.',
          }),
          'error',
          'requests',
        );
      });
  };

  const setGroupJoinRequest = (status, notification, onSuccess) => {
    const groupId = notification?.extra_info?.room_id || notification?.extra_info?.group_id;
    const groupMemberId = notification?.extra_info?.room_member_id || notification?.extra_info?.group_member_id;
    if (!groupId || !groupMemberId) {
      showNotification(
        intl.formatMessage({
          id: 'notifications.group_join_request.action_error',
          defaultMessage: 'Could not update the group join request.',
        }),
        'error',
        'requests',
      );
      return;
    }

    const endpoint =
      status === 'accepted'
        ? `/groups/${groupId}/requests/members/${groupMemberId}/approve`
        : `/groups/${groupId}/requests/members/${groupMemberId}/decline`;

    const announceGroupRequestChange = () => {
      if (typeof window === 'undefined') return;
      const detail = { groupId, groupMemberId, status };
      try {
        window.dispatchEvent(new CustomEvent('nettgrav:groups-directory-refresh', { detail }));
      } catch {}
      try {
        window.localStorage?.setItem(
          'nettgrav:groups-directory-refresh',
          JSON.stringify({ ...detail, at: Date.now() }),
        );
      } catch {}
    };

    request(endpoint, {}, 'post')
      .then(() => {
        showNotification(
          status === 'accepted'
            ? intl.formatMessage({
                id: 'notifications.group_join_request.accepted',
                defaultMessage: 'Group join request approved.',
              })
            : intl.formatMessage({
                id: 'notifications.group_join_request.declined',
                defaultMessage: 'Group join request declined.',
              }),
          'success',
          'requests',
        );

        const formdata = new FormData();
        formdata.append('status', status === 'accepted' ? 'accepted' : 'rejected');
        formdata.append('show_button', false);
        formdata.append('read', true);

        request(`/notifications/${notification.id}`, formdata, 'put').then(() => {
          onSuccess && onSuccess();
          announceGroupRequestChange();
        });
      })
      .catch((err) => {
        const serverMessage =
          typeof err?.response?.data?.error === 'string'
            ? err.response.data.error
            : typeof err?.response?.data?.message === 'string'
              ? err.response.data.message
              : null;
        showNotification(
          serverMessage ||
            intl.formatMessage({
              id: 'notifications.group_join_request.action_error',
              defaultMessage: 'Could not update the group join request.',
            }),
          'error',
          'requests',
        );
      });
  };

  const handleDeclineActionButtonClick = () => {
    switch (notification.category) {
      case 'link_grave_approval':
        setLinkGrave('rejected', notification, () => {
          dispatch(setUserNotificationRequestStatusRedux(notification.id, 'rejected'));
        });
        break;
      case 'user_connection_approval':
        setUserConnection('rejected', notification, () => {
          dispatch(setUserNotificationRequestStatusRedux(notification.id, 'rejected'));
        });
        break;
      case 'grave_admin_approval':
        setRelations('rejected', notification, () => {
          dispatch(setUserNotificationRequestStatusRedux(notification.id, 'rejected'));
        });
        break;
      case 'nettgrav_admin_approval_for_grave':
        setRelations('rejected', notification, () => {
          dispatch(setUserNotificationRequestStatusRedux(notification.id, 'rejected'));
        });
        break;
      case 'nettgrav_admin_grave_approval':
      case 'nettgrav_admin_approval_for_grave_ownership':
        setGraveOwner('rejected', notification, () => {
          dispatch(setUserNotificationRequestStatusRedux(notification.id, 'rejected'));
        });
        break;
      case 'company_request':
        setCompanyApproval('rejected', notification, () => {
          dispatch(setUserNotificationRequestStatusRedux(notification.id, 'rejected'));
        });
        break;
      case 'ad_message_request':
        setAdMessageApproval('rejected', notification, () => {
          dispatch(setUserNotificationRequestStatusRedux(notification.id, 'rejected'));
        });
        break;
      case 'grave_invitation_notification':
        setGraveInvitation('rejected', notification, () => {
          dispatch(setUserNotificationRequestStatusRedux(notification.id, 'rejected'));
        });
        break;
      case 'moon_request_notification':
        setMoonRequest('rejected', notification, () => {
          dispatch(setUserNotificationRequestStatusRedux(notification.id, 'rejected'));
        });
        break;
      case 'group_invitation_notification':
        setGroupInvitation('rejected', notification, () => {
          dispatch(setUserNotificationRequestStatusRedux(notification.id, 'rejected'));
        });
        break;
      case 'room_invitation_notification':
        setRoomInvitation('rejected', notification, () => {
          dispatch(setUserNotificationRequestStatusRedux(notification.id, 'rejected'));
        });
        break;
      case 'group_join_request_notification':
        setGroupJoinRequest('rejected', notification, () => {
          dispatch(setUserNotificationRequestStatusRedux(notification.id, 'rejected'));
        });
        break;
      default:
        return;
    }
    dispatch(
      setUserNotificationButton({
        ...notification,
        show_button: false,
        status: 'rejected',
      }),
    );
  };

  const handleAcceptActionButtonClick = () => {
    switch (notification.category) {
      case 'link_grave_approval':
        setLinkGrave('accepted', notification, () => {
          dispatch(setUserNotificationRequestStatusRedux(notification.id, 'accepted'));
        });
        break;
      case 'user_connection_approval':
        setUserConnection('accepted', notification, () => {
          dispatch(setUserNotificationRequestStatusRedux(notification.id, 'accepted'));
        });
        break;
      case 'grave_admin_approval':
        setRelations('accepted', notification, () => {
          dispatch(setUserNotificationRequestStatusRedux(notification.id, 'accepted'));
        });
        break;
      case 'nettgrav_admin_approval_for_grave':
        setRelations('accepted', notification, () => {
          dispatch(setUserNotificationRequestStatusRedux(notification.id, 'accepted'));
        });
        break;
      case 'nettgrav_admin_grave_approval':
      case 'nettgrav_admin_approval_for_grave_ownership':
        setGraveOwner('accepted', notification, () => {
          dispatch(setUserNotificationRequestStatusRedux(notification.id, 'accepted'));
        });
        break;
      case 'company_request':
        setCompanyApproval('accepted', notification, () => {
          dispatch(setUserNotificationRequestStatusRedux(notification.id, 'accepted'));
        });
        break;
      case 'ad_message_request':
        setAdMessageApproval('accepted', notification, () => {
          dispatch(setUserNotificationRequestStatusRedux(notification.id, 'accepted'));
        });
        break;
      case 'grave_invitation_notification':
        setGraveInvitation('accepted', notification, () => {
          dispatch(setUserNotificationRequestStatusRedux(notification.id, 'accepted'));
        });
        break;
      case 'moon_request_notification':
        setMoonRequest('accepted', notification, () => {
          dispatch(setUserNotificationRequestStatusRedux(notification.id, 'accepted'));
        });
        break;
      case 'group_invitation_notification':
        setGroupInvitation('accepted', notification, () => {
          dispatch(setUserNotificationRequestStatusRedux(notification.id, 'accepted'));
        });
        break;
      case 'room_invitation_notification':
        setRoomInvitation('accepted', notification, () => {
          dispatch(setUserNotificationRequestStatusRedux(notification.id, 'accepted'));
        });
        break;
      case 'group_join_request_notification':
        setGroupJoinRequest('accepted', notification, () => {
          dispatch(setUserNotificationRequestStatusRedux(notification.id, 'accepted'));
        });
        break;
      default:
        return;
    }
    dispatch(
      setUserNotificationButton({
        ...notification,
        show_button: false,
        status: 'accepted',
      }),
    );
  };

  return (
    <div className={`buttons${inline ? ' inline' : ''}`}>
      <Button size="sm" onClick={handleDeclineActionButtonClick}>
        <FormattedMessage id="decline" defaultMessage="Decline" />
      </Button>
      <Button
        variant="filled"
        color="primary"
        size="sm"
        className="yellow"
        onClick={handleAcceptActionButtonClick}
      >
        <FormattedMessage id="accept" defaultMessage="Accept" />
      </Button>
    </div>
  );
};

export default RequestActionButtons;
